import { useQuery } from '@apollo/client';
import { useMe } from '@crehana/auth';

import GET_USER_ORGANIZATION_QUERY from './graphql/GetUserOrganizationQuery.v5.graphql';
import type {
  GetUserORganizationQuery,
  GetUserORganizationQueryVariables,
} from './graphql/types/GetUserORganizationQuery';

const useGetUserOrganizationQuery = () => {
  const { me } = useMe();
  const { data, loading } = useQuery<
    GetUserORganizationQuery,
    GetUserORganizationQueryVariables
  >(GET_USER_ORGANIZATION_QUERY, {
    variables: {
      user_email: me?.email ?? '',
    },
    skip: !me?.email,
    context: { clientName: 'v5' },
  });

  return {
    userIdCentralized: data?.get_user_organization?.user_id,
    email: data?.get_user_organization?.user?.email,
    userStatusCentralized: data?.get_user_organization?.status,
    loading,
  };
};

export default useGetUserOrganizationQuery;
